import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('package_resource_type'),
	fieldsMap.get('sort_index')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
